import NotificationCard
  from "./NotificationCard";

import VexaToast
  from "./VexaToast";

export default function NotificationCenter({

  notifications,

  removeNotification

}) {

  return (

    <div

      style={{

        position:"fixed",

        top:"max(16px, env(safe-area-inset-top))",

        right:"max(16px, env(safe-area-inset-right))",

        width:"min(420px, calc(100vw - 32px))",

        display:"flex",

        flexDirection:"column",

        gap:10,

        zIndex:999999,

        pointerEvents:"none"

      }}

    >

      {notifications.map(

        (

            notification,

            index

        ) => notification.source === "vexa-alert" ? (

            <VexaToast
              key={notification.id}
              notification={notification}
              removeNotification={removeNotification}
            />

        ) : (

            <NotificationCard
              key={notification.id}
              notification={notification}
              index={index}
              total={notifications.length}
              removeNotification={removeNotification}
            />

        )

      )}

    </div>

  );

}
